import { Component, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Router } from "@angular/router";

@Component({
    selector: 'navbar',
    templateUrl: './topnavigation.component.html',
    animations: [
        trigger('slideInOut', [
            state('in', style({
                right: '0'
            })),
            state('out', style({
                right: '-260px'
            })),
            transition('in => out', animate('400ms ease-in-out')),
            transition('out => in', animate('400ms ease-in-out'))
        ]),
    ]
})
export class TopnavigationComponent implements OnInit {

    userName: string;
    userinitial: string;
    organizationName: string;
    roleName: string;
    activeSubscriptions: string = "";
    activeSubscriptionsDashboard: string = "";
    activeSubscriptionsApplications: string = "";
    activeRedemptions: string = "";
    activeRedemptionsDashboard: string = "";
    activeRedemptionsRequests: string = "";
    activeClass3: string = "";

    constructor(private router: Router) { }

    ngOnInit(): void {
        var activeUrl = this.router.url;

        if (activeUrl.indexOf("subscriptions/reporting/site-traffic") > 0) {
            this.activeSubscriptions = "selected";
            this.activeSubscriptionsDashboard = "selected";
        }

        if (activeUrl.indexOf("subscriptions/applications/application-details") > 0) {
            this.activeSubscriptions = "selected";
            this.activeSubscriptionsApplications = "selected";
        }

        if (activeUrl.indexOf("redemptions/reporting/site-traffic") > 0) {
            this.activeRedemptions = "selected";
            this.activeRedemptionsDashboard = "selected";
        }

        if (activeUrl.indexOf("redemptions/requests/request-details") > 0) {
            this.activeRedemptions = "selected";
            this.activeRedemptionsRequests = "selected";
        }

        if (activeUrl.indexOf("investors/investor-details") > 0) {
            this.activeClass3 = "selected";
        }

        this.userName = "Glen Alexander";
        this.userinitial = "GA";
        this.organizationName = "Computershare";
        this.roleName = "Supervisor";
    }

    isBtnActive: boolean = false;

    menuState: string = 'out';

    toggleMenu() {
        // 1-line if statement that toggles the value:
        this.menuState = this.menuState === 'out' ? 'in' : 'out';
        this.isBtnActive = !this.isBtnActive;
    }

    onLogOff() {
        this.router.navigate(['/']);
    }

}
